<template>
  <div>
    <label
      class="ts-shadow-rounded ts-uppercase ts-p-2 ts-rounded-md"
      >{{ $t('saleContract.item') }}</label
    >
    <table class="ts-w-full ts-mt-2">
      <thead>
        <tr>
          <th
            class="ts-uppercase ts-border ts-px-2 ts-py-1 ts-border-gray-300"
          >
            {{ $t('saleContract.barcode') }}
          </th>
          <th
            class="ts-uppercase ts-border ts-px-2 ts-py-1 ts-border-gray-300 ts-w-1/4"
          >
            {{ $t('saleContract.productName') }}
          </th>
          <th
            class="ts-uppercase ts-border ts-px-2 ts-py-1 ts-border-gray-300 ts-w-32"
          >
            {{ $t('saleContract.quantity') }}
          </th>
          <th
            class="ts-uppercase ts-border ts-px-2 ts-py-1 ts-border-gray-300 ts-w-32"
          >
            {{ $t('saleContract.uom') }}
          </th>
          <th
            class="ts-uppercase ts-border ts-px-2 ts-py-1 ts-border-gray-300 ts-w-40"
          >
            {{ $t('saleContract.unitPrice') }}
          </th>
          <th
            class="ts-uppercase ts-border ts-px-2 ts-py-1 ts-border-gray-300 ts-w-64"
          >
            {{ $t('saleContract.grandTotal') }}
          </th>
          <th class="ts-uppercase ts-border ts-px-2 ts-py-1 ts-border-gray-300">
            {{ $t('saleContract.remark') }}
          </th>
          <th
            class="ts-uppercase ts-border ts-px-2 ts-py-1 ​ts-text-center ts-w-1"
          >
            <a href="#" @click.prevent="() => show_modal = true">
              <i class="fa fa-plus"></i>
            </a>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(detail, index) in model.item_list" :key="index">
          <td class="ts-px-2 ts-py-1">
            <input type="text"
              :value="findProduct(detail.product_id).barcode"
              class="ts-py-1 ts-px-2 ts-w-full ts-outline-none"
              readonly
            >
          </td>
          <td class="ts-px-2 ts-py-1">
            <input type="text"
              :value="findProduct(detail.product_id).product_name_en"
              class="ts-py-1 ts-px-2 ts-w-full ts-outline-none"
              readonly
            >
            <div
              class="validate"
              v-if="errors.has('item_list.' + index + '.product_id')"
            >
              {{ errors.first('item_list.' + index + '.product_id') }}
            </div>
          </td>
          <td>
            <input
              v-model.number="detail.quantity"
              type="number"
              class="form-control"
              @input="calculate"
              @keypress.enter="onQtyEnter(index)"
            />
            <div
              class="validate"
              v-if="errors.has('item_list.' + index + '.quantity')"
            >
              {{ errors.first('item_list.' + index + '.quantity') }}
            </div>
          </td>
          <td>
            <a-select
              ref="uom"
              v-model="detail.uom_id"
              class="ts-w-full"
              :class="{
                'is-invalid': errors.has('item_list.' + index + '.uom_id'),
              }"
              @change="onUomChange(detail)"
              @keydown.native.enter="onUomEnter(index)"
            >
              <a-select-option
                v-for="(u, index) in getUom(detail.product_id)"
                :key="index"
                :value="u.uom_id"
                >{{ u.uom_name_en }}
              </a-select-option>
            </a-select>
            <div
              class="validate"
              v-if="errors.has('item_list.' + index + '.uom_id')"
            >
              {{ errors.first('item_list.' + index + '.uom_id') }}
            </div>
          </td>
          <td>
            <ts-currency-input
              v-model.number="detail.unit_price"
              @input="calculate"
              class="ts-text-right"
            />
          </td>
          <td>
            <ts-currency-input
              v-model="detail.amount"
              readonly
              disabled
            />
          </td>
          <td>
            <input
              v-model.trim="detail.remarks"
              type="text"
              class="form-control"
              @keypress.enter="onRemarkEnter(index)"
            />
            <div
              class="validate"
              v-if="errors.has('item_list.' + index + '.remarks')"
            >
              {{ errors.first('item_list.' + index + '.remarks') }}
            </div>
          </td>
          <td class="ts-text-center" valign="middle">
            <a
              href="#"
              class="ts-text-red-600 ts-my-auto"
              @click.prevent="removeRow(detail)"
            >
              <i class="fa fa-trash"></i>
            </a>
          </td>
        </tr>
        <tr>
          <td colspan="4"></td>
          <td class="text-right ts-p-2">
            <div class="ts-border ts-w-full ts-py-1 ts-px-2 ts-float-right ts-rounded">
              <b>{{ $t('saleContract.vatRate') }}</b>
            </div>
          </td>
          <td class="ts-p-2">
            <div class="ts-border ts-w-full ts-py-1 ts-px-2 ts-float-right ts-rounded ts-text-right">
            <b>{{ model.vat_rate ? model.vat_rate : 0 }}</b>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="4"></td>
          <td class="text-right ts-p-2">
            <div class="ts-border ts-w-full ts-py-1 ts-px-2 ts-float-right ts-rounded">
              <b> {{ $t('saleContract.vatAmount') }}</b>
            </div>
          </td>
          <td class="ts-p-2">
            <div class="ts-border ts-w-full ts-py-1 ts-px-2 ts-float-right ts-rounded ts-text-right">
              <b>{{ model.vat_amount ? model.vat_amount : 0 }}</b>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="4"></td>
          <td class="text-right ts-p-2">
             <div class="ts-border ts-w-full ts-py-1 ts-px-2 ts-float-right ts-rounded ts-whitespace-no-wrap">
                <b>{{ $t('saleContract.totalExcludevat') }}</b> 
             </div>
          </td>
          <td class="ts-p-2">
            <div class="ts-border ts-w-full ts-py-1 ts-px-2 ts-float-right ts-rounded ts-text-right">
              <b>{{ model.total_exclude_vat ? model.total_exclude_vat : 0 }}</b>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="4"></td>
          <td class="text-right ts-p-2">
            <div class="ts-border ts-w-full ts-py-1 ts-px-2 ts-float-right ts-rounded">
              <b>{{ $t('saleContract.grandTotal') }}</b>
            </div>
          </td>
          <td class="ts-p-2">
            <div class="ts-border ts-w-full ts-py-1 ts-px-2 ts-float-right ts-rounded ts-text-right">
              <b>{{ model.grand_total ? model.grand_total : 0 }}</b>
            </div>
            
          </td>
        </tr>
      </tbody>
    </table>
      <a-modal
      v-if="show_modal"
      v-model="show_modal"
      :title="$t('saleContract.productList')"
      :footer="null"
      :maskClosable="false"
      :centered="true"
      width="600px"
      :zIndex="1020"
    >
      <ProductList v-model="model"  @calculate="calculate"/>
    </a-modal>

  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import ProductList from './product-list.vue'

export default {
  name: 'ItemDetails',
  props: ['value', 'validate'],
  components: {
    ProductList,
  },
  data() {
    return {
      errors: new Errors(),
      show_modal: false,
      newRow: {
        product_id: '',
        uom_id: '',
        quantity: 1,
        unit_price: '',
        remarks: '',
        amount: 0,
      },
    }
  },
  computed: {
    ...mapState('wholesale/saleContract', ['edit_data']),
    ...mapGetters('wholesale/saleContract', [
      'getUom',
      'getSalePrice',
      'findProduct'
    ])
  },
  created() {
    this.model = this.value
  },
  methods: {
    addNewRow() {
      this.model.item_list.push(_.clone(this.newRow))
    },
    removeRow(row) {
      this.model.item_list.splice(this.model.item_list.indexOf(row), 1)
    },
    onUomChange(row) {
      row.unit_price = this.getSalePrice({
        product_id: row.product_id,
        uom_id: row.uom_id,
      })
      this.calculate()
    },
    calculate() {
      if (this.model.item_list.length > 0) {
        this.model.item_list.forEach((el) => {
          el.amount = _.round(el.quantity * el.unit_price, 2)
        })
        var sum = _.sumBy(this.model.item_list, (o) => o.amount)
        this.model.vat_amount = _.round(sum * (this.model.vat_rate / 100), 2)
        this.model.grand_total = _.round(this.model.vat_amount + sum, 2)
        this.model.total_exclude_vat = _.round(
          this.model.grand_total - this.model.vat_amount,
          2
        )
      }
    },
    onUomEnter(index){
      this.addNewRow()
      this.$nextTick(() => {
        this.$refs.product[index + 1].focus()
      })
    },
    onRemarkEnter(index){
      this.addNewRow()
      this.$nextTick(() => {
        this.$refs.product[index + 1].focus()
      })
    },
    onQtyEnter(index){
      this.$nextTick(() => {
        this.$refs.uom[index].focus()
      })
    }
  },
  watch: {
    validate: function (error) {
      this.errors = new Errors(error.errors)
    },
  },
}
</script>